var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ui-textarea", {
    staticClass: "checkout-comment",
    attrs: {
      height: "120",
      label: _vm.label,
      placeholder: "Комментарий к заказу"
    },
    on: { input: _vm.saveComment },
    model: {
      value: _vm.comment,
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }